export default "__VITE_ASSET__BnGr9yGD__"